<template>
  <div ref="root" class="page02 container">
    <div class="row">
      <div class="title_num">02</div>
      <h1 class="title" v-html="content.descr" />
    </div>

    <el-collapse v-model="activeNames" >
      <div :name="i" v-for="(item, i) of list">
        <Page2AccordeonIE v-if="$isIE" :content='item' :active="activeNames" :item='i' ref="acc" />
        <Page2Accordeon v-else :content='item' :item='i' ref="acc" />
      </div>
    </el-collapse>

  </div>
</template>

<script>
import Page2Accordeon from '@/components/Page2Accordeon.vue'
import Page2AccordeonIE from '@/components/Page2AccordeonIE.vue'
import {chapterList} from '../content2.js'

// console.log(chapterList)

export default {
  name: 'Page02',
  data () {
    return {
      activeNames: 0,
      content: chapterList,
      list: chapterList.list,
    }
  },
  watch:{
    $route (to, from){
      this.menuCheck()
      setTimeout( () => {
        this.$refs.root.querySelector('.el-collapse-item.is-active').scrollIntoView({ behavior: 'smooth' })
      },300)
      this.activeNames = this.$route.params.id - 1
        // this.show = false;
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },

  },
  components: {
    Page2Accordeon,
    Page2AccordeonIE,
  },
  mounted () {
    this.menuCheck()
    // console.log(this.$route.params.id)
    setTimeout( () => {
      this.$refs.root.querySelector('.el-collapse-item.is-active').scrollIntoView({ behavior: 'smooth' })
    },300)
    this.activeNames = this.$route.params.id - 1
    // this.$refs.start.scrollIntoView({ behavior: 'smooth' })
    
    // this.$refs.acc[0].onOpen()
  },
  methods: {
    menuCheck() {
      if(this.$store.state.menuOpen) {
        this.$store.dispatch('menuToggle')
      }
    },
  }
}
</script>
<style lang="stylus">
@import '../cofig.styl'

.accordeon_list
  padding-top 25px

.page02
  .el-collapse-item__header
    margin-bottom 20px
  .el-collapse-item__arrow
    position relative
    @media screen and (max-width: 900px)
      margin 0 2px 0 auto
    &:before, &:after
      content ''
      position absolute
      top -5px
      right 0
      width 17px
      height 4px
      background $color
      border-radius 3px
      transition background .3s
      @media screen and (max-width: 900px)
        width 9px
        height 2px
        top -1px
    &:before
      right 5px
      transform rotate(45deg)
      @media screen and (max-width: 900px)
        right 1px
    &:after
      right -5px
      transform rotate(-45deg)
  .el-collapse-item__arrow.is-active
    transform none
    &:before
      width 17px
      background $colorSel
      transform rotate(0)
      @media screen and (max-width: 900px)
        width 9px
    &:after
      display none
</style>